import { Stack, Typography } from "@mui/material";
import StyledFormLabels from "customStyled/StyledFormLabels";
import { useTranslation } from "react-i18next";

const FormLabel = (props) => {
  const { t } = useTranslation("form");
  const { label, required, id } = props;
  return (
    <>
      {label ? (
        // the id names selects (role="combobox" divs, which <label for> can't)
        <StyledFormLabels htmlFor={id} id={id ? `${id}-label` : undefined}>
          <Stack direction={"row"} sx={{ gap: "12px" }}>
            <Stack direction={"row"} sx={{ gap: 0.5 }}>
              {label}
            </Stack>
            {required ? null : (
              <Typography variant="h6" sx={{ color: "#70737B" }}>
                {t("optional")}
              </Typography>
            )}
          </Stack>
        </StyledFormLabels>
      ) : null}
    </>
  );
};

export default FormLabel;
